import React from 'react';

import './styles.scss';

interface RequiredAsteriskInterface {
  color?: string;
}

const RequiredAsterisk: React.FC<RequiredAsteriskInterface> = ({ color }) => {
  return (
    <span className="required-asterisk" style={{ color }}>
      *
    </span>
  );
};

export default RequiredAsterisk;
